var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-card" },
    [
      _c("svg-icon", {
        attrs: {
          "icon-class": !_vm.isQrLogin ? "wxicon" : "pcicon",
          "class-name": "angle-pic"
        },
        on: { click: _vm.loginTypeToggle }
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isQrLogin,
              expression: "!isQrLogin"
            }
          ],
          staticClass: "username-login"
        },
        [
          _c("h2", [_vm._v("欢迎登录" + _vm._s(_vm.isYTS ? "云图梭" : ""))]),
          _c("div", { staticClass: "dv-tip" }, [
            _vm._v(_vm._s(_vm.doubleVerifyTip))
          ]),
          _c(
            "el-form",
            {
              ref: "loginForm",
              staticClass: "login-form",
              attrs: { model: _vm.loginForm, rules: _vm.loginRules },
              nativeOn: {
                submit: function($event) {
                  $event.preventDefault()
                },
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.confirm.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "el-form-item",
                { staticClass: "login-name", attrs: { prop: "username" } },
                [
                  _c("el-input", {
                    class: ["account", _vm.userError ? "user-error" : ""],
                    attrs: {
                      placeholder: "飞梭ID / 手机号",
                      autocomplele: "off",
                      clearable: "",
                      spellcheck: "false"
                    },
                    on: {
                      focus: function($event) {
                        _vm.userError = false
                      }
                    },
                    model: {
                      value: _vm.loginForm.username,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.loginForm,
                          "username",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "loginForm.username"
                    }
                  }),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.userError,
                          expression: "userError"
                        }
                      ],
                      staticClass: "item-error"
                    },
                    [_vm._v(_vm._s(_vm.userErrorText))]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "login-pasw", attrs: { prop: "pasw" } },
                [
                  _c("el-input", {
                    ref: "paswInput",
                    class: ["password", _vm.passwError ? "pasw-error" : ""],
                    attrs: {
                      type: _vm.paswshow,
                      placeholder: "密码",
                      autocomplete: "off",
                      clearable: "",
                      spellcheck: "false"
                    },
                    on: {
                      focus: function($event) {
                        return _vm.paswFocus($event)
                      }
                    },
                    model: {
                      value: _vm.loginForm.pasw,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.loginForm,
                          "pasw",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "loginForm.pasw"
                    }
                  }),
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.loginForm.pasw.length > 0 &&
                          _vm.paswshow === "password",
                        expression:
                          "loginForm.pasw.length>0 && paswshow === 'password'"
                      }
                    ],
                    staticClass: "pasw-eyes",
                    attrs: {
                      src: require("../../../assets/image/login/eye-close.svg"),
                      alt: ""
                    },
                    on: { click: _vm.showPass }
                  }),
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.loginForm.pasw.length > 0 &&
                          _vm.paswshow === "text",
                        expression:
                          "loginForm.pasw.length>0 && paswshow === 'text'"
                      }
                    ],
                    staticClass: "pasw-eyes",
                    attrs: {
                      src: require("../../../assets/image/login/eye-open.svg"),
                      alt: ""
                    },
                    on: { click: _vm.showPass }
                  }),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.passwError,
                          expression: "passwError"
                        }
                      ],
                      staticClass: "item-error"
                    },
                    [_vm._v(_vm._s(_vm.paswErrorText))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticClass: "login-submit",
              attrs: { disabled: _vm.confirmDisabled, type: "primary" },
              on: { click: _vm.confirm }
            },
            [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.loginText !== "登录",
                      expression: "loginText !== '登录'"
                    }
                  ],
                  staticClass: "login-icon2"
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("../../../assets/image/login/loading.svg"),
                      alt: ""
                    }
                  })
                ]
              ),
              _vm._v(" " + _vm._s(_vm.loginText) + " ")
            ]
          ),
          _c("div", { staticClass: "footer" }, [
            _c(
              "span",
              {
                staticClass: "code-login",
                class: { "split-line": _vm.isYTS },
                on: { click: _vm.changeType }
              },
              [_vm._v("短信登录")]
            ),
            _c("span", { on: { click: _vm.forgetPsw } }, [_vm._v("找回密码")]),
            _vm.isYTS
              ? _c("span", { on: { click: _vm.register } }, [
                  _vm._v("立即注册")
                ])
              : _vm._e()
          ])
        ],
        1
      ),
      _vm.isQrLogin
        ? _c("div", { staticClass: "qr-login" }, [
            _vm._m(0),
            _c(
              "div",
              { class: ["qr-code-box", { "qr-code-err": _vm.qrCodeInvalid }] },
              [
                _c(
                  "div",
                  { staticClass: "qr-code" },
                  [
                    _c("vue-qr", { attrs: { text: _vm.qrCodeInfo, size: 200 } })
                  ],
                  1
                ),
                _vm.qrCodeInvalid
                  ? _c(
                      "div",
                      { staticClass: "qr-err", on: { click: _vm.refreshQr } },
                      [
                        _c("svg-icon", {
                          attrs: {
                            "icon-class": _vm.errorIcon,
                            "class-name": "error-icon"
                          }
                        }),
                        _c("p", [_vm._v(_vm._s(_vm.qrInvalidMsg))]),
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.isOnline ? "刷新二维码" : "请检查网络")
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          ])
        : _vm._e(),
      _c("p", { staticClass: "footer-tip" }, [
        _vm._v("登录即表示同意"),
        _c("span", { on: { click: _vm.showProtocol } }, [_vm._v("用户协议")]),
        _vm._v("和"),
        _c("span", { on: { click: _vm.showPrivacy } }, [_vm._v("隐私政策")])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [
      _c("h2", [_vm._v("扫码登录")]),
      _c("p", [_vm._v("请使用云图梭移动端扫描二维码")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }